import { Component, OnInit } from '@angular/core';
import { Location, LocationService } from "services/location.service";

@Component({
	selector: 'ras-rent-now-page',
	templateUrl: './rent-now-page.component.html',
	styleUrls: ['./rent-now-page.component.sass']
})
export class RentNowPageComponent implements OnInit {

	public locations: Location[] = []
	public show_popup = false

	constructor(private locationService: LocationService) { }

	ngOnInit(): void {
		this.locationService.get_all()
		.then(locations => {
			this.locations = locations
		})
	}

}
